import { app } from '../../../../app';

app.factory('UserProvisioningService', UserProvisioningService);

/** @ngInject */
function UserProvisioningService($resource) {
    var rootUrl = 'app/rest/admin/company/:companyId/application/:appId/manageapp/userprovisioning';

    return {       
        provisioningConfiguration : $resource(rootUrl,{},{
            'updateAutoProvisioning' : {
                method : 'PUT',
            },
            'updateVerificationEmailFlag':{
                method : 'PUT',
                url : rootUrl+'/verificationEmail',
            }
        }),
        userProvisioningAction : $resource(rootUrl+ '/disable'),
        userProvisioningTest :  $resource(rootUrl+ '/testConnection',{},{ 'testConnection': {
                method: 'POST',
                isArray: true
            }} ),
        userProvisioningImport :  $resource(rootUrl+ '/import'),
        userProvisioningExport :  $resource(rootUrl+ '/export'),
        userProvisioningLicenses : $resource(rootUrl+ '/licences')
    }
    

}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/scim-provisioning/scim-provisioning.service.js